import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { AuthService } from '../services/auth.service';

const STANDARD_API_PATH = 'login.trackserver.co.uk/api/';
// Auth endpoints must never be blocked — they are used by the login flow itself
const AUTH_PATHS = ['/MobileApp/Login', '/Login/Login'];

export const adminBlockInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const auth = inject(AuthService);

  const isAuthRequest = AUTH_PATHS.some(p => req.url.includes(p));
  // Block standard API calls only for a pure admin session (no sub-account selected yet)
  if (!isAuthRequest && auth.isAdmin() && !auth.getSessionId() && req.url.includes(STANDARD_API_PATH)) {
    return EMPTY;
  }

  return next(req);
};
